export enum ENodeLevels {
  parent = 'parent-level',
  child = 'child-level',
  document = 'document-level',
  parentOrChild = 'parent-or-child-level',
}
